import { setTemplates, setSaveTemplateRequestStatus } from ".";
import { AppThunk } from "../store";
import { RequestStatus } from "constants/RequestStatus";
import { templatesService } from "services/templatesService";

export const getAllTemplates = (): AppThunk => async (dispatch) => {
  try {
    const { data } = await templatesService.getAll();

    const promises = data.map(async (template) => {
      const file = await templatesService.getFileById(template.snapshot);
      return { ...template, file };
    });

    const results = await Promise.all(promises);
    dispatch(setTemplates(results));
  } catch (error) {
    console.error(error);
  }
};

export const postNewTemplate =
  (bodyData: any): AppThunk =>
  async (dispatch) => {
    dispatch(setSaveTemplateRequestStatus(RequestStatus.Loading));
    try {
      const { data } = await templatesService.create(bodyData);
      dispatch(setSaveTemplateRequestStatus(RequestStatus.Success));
      return data;
    } catch (error) {
      dispatch(setSaveTemplateRequestStatus(RequestStatus.Failed));
    }
  };
